import { useCallback } from 'react';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { ID } from 'shared/types/id';

import { TreeItem } from './types';

export type Options = {
  onCollapse?: (ids: ID[]) => void;
};

export const useKeyboardShortcuts = (
  items: Record<ID, TreeItem>,
  { onCollapse }: Options,
) => {
  const expandAll = useCallback(() => onCollapse?.([]), [onCollapse]);
  const collapseAll = useCallback(
    () => onCollapse?.(Object.keys(items)),
    [items, onCollapse],
  );

  useKeysDown(['ControlLeft', 'ShiftLeft', 'KeyE'], expandAll);
  useKeysDown(['ControlRight', 'ShiftLeft', 'KeyE'], expandAll);
  useKeysDown(['ControlLeft', 'ShiftRight', 'KeyE'], expandAll);
  useKeysDown(['ControlRight', 'ShiftRight', 'KeyE'], expandAll);

  useKeysDown(['ControlLeft', 'ShiftLeft', 'KeyC'], collapseAll);
  useKeysDown(['ControlLeft', 'ShiftRight', 'KeyC'], collapseAll);
  useKeysDown(['ControlRight', 'ShiftLeft', 'KeyC'], collapseAll);
  useKeysDown(['ControlRight', 'ShiftRight', 'KeyC'], collapseAll);
};
